/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react';

export function useClientSideSearch({ search, list, key }) {
  const filteredList = useMemo(
    () => {
      if (search) {
        let res = [];
        list?.forEach((item) => {
          if (
            String(item[key])?.toLowerCase()?.includes(search?.toLowerCase())
          ) {
            res?.push(item);
          }
        });
        return res;
      }

      //default return
      return list;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search, list],
  );

  return { filteredList };
}
